 <template>
    <div class="clinic">
        <studySearch ref="studySearch"  
        :hotwordList="hotwordList" 
        :sourceType="'topic'"
        @searchClick="getTopicList(1)"></studySearch>
        <div class="clinic-cont">
            <div class="cont-tit">查题库</div>
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb"> 
                <el-breadcrumb-item>{{firstClassification?firstClassification:'全部'}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{secondClassification?secondClassification:'' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <ul class="clinic-list">
                <li  v-for="(item,index) in listInfo" :key="index">
                    <a @click="toPage(item)" target="_blank">
                        <div class="list-info">
                            <div class="info-tit">{{ item.questionSource }}{{item.questionName}} {{item.questionContent }}</div>
                            <div class="info"> 
                                <div v-if='item.createTime'>
                                    <p class="info-label">发布时间：</p>
                                    <p class="info-value">{{item.createTime}}</p>
                                </div> 
                            </div>
                        </div>
                    </a> 
                </li> 
            </ul>
            <div class="no-data" v-if="listInfo.length==0">暂无数据～</div>
            <el-pagination
                v-if="pageInfo.total!=0"
                @current-change="changePage" 
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize" 
                :total="pageInfo.total"
                background
                layout="total, prev, pager, next" >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import studySearch from './comps/study_search.vue'

import { secondList, searchListTK, saveFrontLog } from '../../io/api';
export default {
    components:{
        studySearch
    },
    data () {
        return {
            searchVal:this.$route.query.searchWord||'',
            subType:this.$route.query.subType||1,
            firstClassification:this.$route.query.firstClassification||'',
            secondClassification:this.$route.query.secondClassification||'',
            hotwordList: [
                { val: '孙思邈' },
                { val: '金匮要略' },
                { val: '伤寒论' },
                { val: '钱乙' }, 
            ],
            listInfo:[ ], 
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
        }
    },
    mounted(){
        this.getTopicList(1);
    },
    methods: { 
        getTopicList(num){
            this.searchVal=this.$store.state.study.searchVal;
            let params={
                page: num?num:this.pageInfo.pageNum,
                limit: 10,
                question:this.searchVal
            }
            searchListTK(params).then(res=>{
                let {code,data,msg}=res.data;
                if(code==0){
                    if(data.list ){
                        this.listInfo = [].concat(data.list);
                        this.pageInfo.total=data.total||0;
                    }else{
                        if(this.searchVal==''){
                            window.open(data,'_self');
                            return;
                        } 
                    }
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })
        },
        toPage(item){
            let url = this.$router.resolve({ 
                path: '/detailsTopic', 
                query:{
                    topicId:item.id||'',
                } 
            })
            this.$windowOpen({ url: url.href, isLogin: true })
            // 查题库不调用 saveFrontLog
            // const title = item.questionName || item.questionContent || item.questionSource || ''
            // saveFrontLog({
            //     moduleName: '查题库',
            //     operationType: '查看详情',
            //     logContent: `查看【${title}】数据详情。`,
            // })
        },
        changePage(num){
            this.pageInfo.pageNum=num;
            this.getTopicList(num);
        },
        //banner检索
        banner_search(val){ 
            this.searchVal=val;
            this.getTopicList(1); 
        },  
    }
}
</script>

<style lang="less" scoped>
.clinic{ 
    .clinic-cont{
        width: 1200px;
        margin: 40px auto;
        ::v-deep .el-breadcrumb{
            margin-bottom: 30px;
            font-size: 16px;  
            font-weight: bold;
            .el-breadcrumb__inner{
                color: #386DE8;
            } 
        }
        .cont-tit{
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #303133;
            text-align: center;
        }
    }
    .tit{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 30px;
    } 
    .clinic-list{
        li{
            display: flex;
            padding-bottom: 20px;
            border-bottom: 1px solid #C0D9F6;
            margin-bottom: 20px;  
            // &:hover{
            //     background: #EAF1FF;
            //     box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.04);
            // }
            .list-pic{
                width: 240px;
                height: 140px;
                margin-right: 20px;
                border-radius: 6px;
                overflow: hidden;
            }
            .list-info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 20px 0;
                // flex-direction: column;
                // justify-content: center;
                .info-tit{
                    font-size: 16px;
                    font-weight: bold; 
                    cursor: pointer;
                    &:hover{
                        color: #000;
                    }
                }
                .info{
                    display: flex;  
                    >div{
                        display: flex;
                        align-items: center;
                        margin-right:20px ;
                    }
                }
            }
        }

    }
    .no-data{
        text-align: center;
        font-size: 16px;

        padding:80px 0 120px;
    }
}
</style>